import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { OrganizationService } from '../../../../services/organization.service';
import { pageTransitions } from '../../../../../shared/animations/page-transitions';
import { DiffusionServiceParameter } from '../../../../models/user-service';

const values: Record<string, string> = {};

@Component({
	selector: 'copo-dialog-show-parameters',
	templateUrl: './dialog-show-parameters.component.html',
	styleUrl: './dialog-show-parameters.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,

		MatDialogModule,
		FormsModule,
		ReactiveFormsModule,
		NgIf,
		NgFor,

		MatSelectModule,

		MatOptionModule,

		MatButtonModule,
	],
})
export class DialogShowParametersComponent implements OnInit {
	formGroup!: FormGroup;
	constructor(

		@Inject(MAT_DIALOG_DATA) public serviceParams: DiffusionServiceParameter[],

		private readonly dialogRef: MatDialogRef<DialogShowParametersComponent>,
		private readonly organizationService: OrganizationService
	) {
		this.formGroup = new FormGroup({});
		for (const parameter of serviceParams) {
			const parameterValue = parameter.value;
			this.formGroup.addControl(parameter.serviceParameter.id.toString(), new FormControl(parameterValue));
		}
	}

	ngOnInit(): void {
		this.updateParameterValues().then(() => {
			for (const parameter of this.serviceParams) {
				const parameterValue = parameter.value || parameter.serviceParameter.defaultValue;
				values[parameter.serviceParameter.id] = parameterValue;
			}
			this.formGroup.patchValue(values);
		}).catch((err: unknown) => {
			console.error('Error while updating parameter values', err);
		});
		this.dialogRef.updateSize('70%');
		this.dialogRef.disableClose = true;
	}

	cancel() {
		this.dialogRef.close(false);
	}

	validate() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}

	async updateParameterValues() {
		const parameterIds = this.serviceParams.map(parameter => parameter.serviceParameter.id);
		try {
			await this.organizationService.getParameterValuesList(parameterIds)
				.then(results => {
					for (const paramValues of results) {
						for (const parameter of this.serviceParams) {
							if (parameter.serviceParameter.id === paramValues.id) {
								parameter.serviceParameter.availableValues = paramValues.value;
							}
						}
					}
				});
		} catch (err) {
			console.error('Error from http get parameter values', err);
		}
	}
}
